<template>
  <AppLayout>
    <v-container grid-list-md fluid pa-0 class="issues">
      <v-layout justify-center row wrap>
        <v-expansion-panel class="elevation-0 lg9">
          <v-expansion-panel-content v-for="group in comingIssueGroups" :key="group.label">
          <template v-slot:header>
            <span class='panel-header'>
              <v-icon :class="group.classes">handyman</v-icon>
              <span style="padding-left: 1rem;">{{group.label}}</span>
              <v-chip class="end-of" small color="primary" text-color="white">
                {{group.issues.length}}
              </v-chip>
            </span>
          </template>
          <v-flex>
            <v-list v-if="group.issues.length > 0" subheader>
              <template v-for="issue in group.issues">
                <v-list-tile
                  :key="issue.id"
                  class="issue d-flex justify-start"
                  @click="displaySelectedIssue(issue)"
                >
                  <v-list-tile-avatar class="avatar">
                    <v-icon :class="group.classes">handyman</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content class="part1">
                    <v-list-tile-title>
                      {{issue.showStreetAddress}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{issue.showRegion}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-content class="part2">
                    <v-list-tile-title>
                      {{issue.description}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{issue.showStatus}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div style="display:flex" class="chips-container">
                      <v-chip small :class="group.classes">
                       {{ issue.house.lastIssueTimeStamp }}
                      </v-chip>
                      <v-chip small :class="group.classes">
                       {{ issue.lastDays }}
                      </v-chip>
                    </div>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-flex>
        </v-expansion-panel-content>

      </v-expansion-panel>

      </v-layout>
    </v-container>
    <IssueDialog ref="dlg"/>
  </AppLayout>
</template>

<script>
import AppLayout from '@/views/AppLayout'
import { mapGetters, mapActions } from 'vuex'
import issueStatus from '@/helpers/issue_status';
import IssueDialog from '@/components/issues/IssueDialog'

export default {
  name: 'Issues',
  components: {
    AppLayout,
    IssueDialog,
  },
  computed: {
    ...mapGetters({
      issues: 'Issues/get',
    }),
    comingIssues() {
      return this.issues
    },

    comingIssueGroups() {
      const issueGroup = [{
        status: issueStatus.Closed,
        label: 'Closed',
        classes: 'confirming-rerent',
        issues: this.comingIssues.filter(issue => issue.status === issueStatus.Closed)
      }, {
        status: issueStatus.Performed,
        label: 'Performed',
        classes: 'confirming-rerent',
        issues: this.comingIssues.filter(issue => issue.status === issueStatus.Performed)
      }, {
        status: issueStatus.Assigned,
        label: 'Assigned',
        classes: 'waiting-list',
        issues: this.comingIssues.filter(issue => issue.status === issueStatus.Assigned)
      }, {
        status: issueStatus.Proposed,
        label: 'Proposed',
        classes: 'waiting-list',
        issues: this.comingIssues.filter(issue => issue.status === issueStatus.Proposed)
      }];
      console.log('issueGroup', {comingIssues: this.comingIssues, issueGroup})
      return issueGroup;
    }
  },
  async mounted() {
    await this.fetchIssueList();
  },
  methods: {
    ...mapActions({
      fetchIssueList: 'Issues/fetchAll',
      selectIssue: 'Issues/select',
    }),
    async displaySelectedIssue(issue) {
      this.selectIssue(issue);
      await this.$refs.dlg.open()
    },
  }
}
</script>
<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_colors';

.v-list__tile--selected {
  border-left: 5px solid #2484C6;
  background-color: $grey.lighten-3;
}

.issues {
  position: relative;

  &__list .v-list {
    max-height: 80vh;
    overflow-y: scroll;

    > div {
      border-bottom: 1px solid $grey.lighten-2;
    }
  }

  &__list--selected {
    position: sticky;
    top: 80px;
    max-height: 690px;
    padding-right: 20px !important;

    .v-list {
      max-height: 600px;
    }
  }
}

.chips-container {
  .checking-out {
    background: orange;
  }
  .confirming-rerent {
    background: lightgreen;
  }
  .reminding-rerent {
    background: lightblue;
  }
}

.avatar, .panel-header {
  .checking-out {
    color: orange;
  }
  .confirming-rerent {
    color: green;
  }
  .reminding-rerent {
    color: blue;
  }
}

.panel-header {
  padding:4px;
  width: 100%;
  display: flex;
}

.end-of {
  margin-left: auto;
}

.v-chip__content {
  width: 100%;
}

.issue:hover {
  background-color : lightgray;
  border-radius: 5px;
}

 .part1 {
   width: 200px;
 }

 .part2 {
   width: 200px;
 }

</style>
